import React, { useState } from "react";
import AddFine from './add-fine';
import EditFine from './edit-fine';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import moment from 'moment';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { useNotify } from './notify';

export default function Fines() {
    const { notify } = useNotify();
    const [addFineOpen, setAddFineOpen] = useState(false);
    const [editFineOpen, setEditFineOpen] = useState(false);
    const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
    const [recipientTypeFilter, setRecipientTypeFilter] = useState("all");
    const [workerFilter, setWorkerFilter] = useState("all");
    const [editedFineId, setEditedFineId] = useState("");
    const [availableWorkers, setAvailableWorkers] = useState([]);
    const [availableAdmins, setAvailableAdmins] = useState([]);
    const [finesList, setFinesList] = useState([]);
    const api_url = process.env.REACT_APP_API_URL;
    const complexName = localStorage.getItem('complex_name');
    const [totalFines, setTotalFines] = useState(0);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);

    const handleAddFineOpen = () => setAddFineOpen(true);
    const handleAddFineClose = () => setAddFineOpen(false);

    const handleEditFineOpen = () => setEditFineOpen(true);
    const handleEditFineClose = () => setEditFineOpen(false);

    function showEditFineModal(fine_id){
        handleEditFineOpen();
        setEditedFineId(fine_id);
    }

    function showAddFineModal(){
        handleAddFineOpen();
    }

    React.useEffect(() => {
        async function getAvailableWorkers() {
            const requestOptions = {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') },
              body: JSON.stringify({ complex_name: complexName })
            };
            const availableWorkers = await (await fetch(api_url+"/api/allLiveWorkers", requestOptions)).json();
            setAvailableWorkers(availableWorkers.map(({worker_id, full_name, rank, phone_number, complex_name, role}) => ({workerId: worker_id, fullName: full_name, rank: rank, phoneNumber: phone_number, complexName: complex_name, role: role})));
        }

        async function getAvailableAdmins() {
            const requestOptions = {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') },
              body: JSON.stringify({ complex_name: complexName })
            };
            const body = await (await fetch(api_url+"/api/availableAdmins", requestOptions)).json();
            setAvailableAdmins(body.map(({ user_id, fullname }) => ({ userId: user_id, fullName: fullname })));
        }

        async function getFines() {
          setLoading(true);
          const requestBody = {
            start_date: startDate,
            end_date: endDate,
            complex_name: complexName,
            recipient_type_filter: recipientTypeFilter
          };
          if (recipientTypeFilter === 'worker') {
            requestBody.worker_id = workerFilter;
          } else if (recipientTypeFilter === 'user') {
            requestBody.user_id = workerFilter;
          }

          const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token')},
            body: JSON.stringify(requestBody)
          };
          try {
            const fines_list = await fetch(api_url+"/api/allFines", requestOptions);
            const body = await fines_list.json();
            setFinesList(body.map(({ fine_id, fine_date, worker_id, user_id, recipient_type, full_name, fine_amount, complex_name, comment, created_by }) => ({ fine_id, fine_date: new Date(fine_date).toLocaleString("ru-RU", { timeZone: "UTC" }), worker_id, user_id, recipient_type, worker_name: full_name, fine_amount, complex_name, comment, created_by })));

            let temp_total_fines = 0;
            for(var i=0; i < body.length; i++){
               temp_total_fines += body[i].fine_amount;
            }
            setTotalFines(temp_total_fines);
          } catch (e) {
            notify("error", "Не удалось загрузить штрафы");
          } finally {
            setLoading(false);
          }
        }

        getAvailableWorkers();
        getAvailableAdmins();
        getFines();

        }, [startDate, endDate, workerFilter, recipientTypeFilter, addFineOpen, editFineOpen]);

    const pagedFines = finesList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    const colCount = 6;

    return (
        <>
            <Box sx={{pt:5, pb:5}} fullWidth>
            <TextField
                id="start_date"
                label="Дата с"
                type="date"
                defaultValue={startDate}
                sx={{ m: 1.5, width: 220}}
                InputLabelProps={{
                    shrink: true,
                }}
                onChange={e => { setStartDate(e.target.value); setPage(0); }}
            />

            <TextField
                id="end_date"
                label="Дата по"
                type="date"
                defaultValue={endDate}
                sx={{ m: 1.5, width: 220 }}
                InputLabelProps={{
                    shrink: true,
                }}
                onChange={e => { setEndDate(e.target.value); setPage(0); }}
            />

            <FormControl sx={{m: 1.5, width: 220}} >
            <InputLabel id="recipient-type-filter-label">Тип сотрудника</InputLabel>
            <Select
                id="recipient_type_filter"
                value={recipientTypeFilter}
                label="Тип сотрудника"
                onChange={e => {
                    setRecipientTypeFilter(e.target.value);
                    setWorkerFilter("all");
                    setPage(0);
                }}
            >
            <MenuItem value="all">Все</MenuItem>
            <MenuItem value="worker">Мойщик/Кассир/КК</MenuItem>
            <MenuItem value="user">Админ/HR-директор</MenuItem>
            </Select>
            </FormControl>

            {recipientTypeFilter !== 'all' && (
            <FormControl sx={{m: 1.5, width: 250}} >
            <InputLabel id="worker-filter-label">Выберите сотрудника</InputLabel>
            <Select
                id="worker_name"
                value={workerFilter}
                label="Выберите сотрудника"
                onChange={e => { setWorkerFilter(e.target.value); setPage(0); }}
            >
            <MenuItem value="all">Любой</MenuItem>
            {recipientTypeFilter === 'worker'
                ? availableWorkers.map((item) => (
                    <MenuItem key={item.workerId} value={item.workerId}>{item.fullName}</MenuItem>
                  ))
                : availableAdmins.map((item) => (
                    <MenuItem key={item.userId} value={item.userId}>{item.fullName}</MenuItem>
                  ))
            }
            </Select>
            </FormControl>
            )}
            </Box>

            <button className='add-visit-button' onClick={() => showAddFineModal()}>
                <a>Добавить штраф</a>
            </button>

            <Typography m={5} variant="h6">Штрафы за выбранный период: {totalFines}</Typography>

            <TableContainer component={Paper} sx={{ maxHeight: 640 }}>
            <Table stickyHeader sx={{ minWidth: 650 }} aria-label="fines table">
            <TableHead>
            <TableRow>
                <TableCell>Дата</TableCell>
                <TableCell>Сотрудник</TableCell>
                <TableCell align="right">Размер штрафа</TableCell>
                <TableCell>Комментарий</TableCell>
                <TableCell>Добавил</TableCell>
                <TableCell></TableCell>
            </TableRow>
            </TableHead>
            <TableBody>
            {loading ? (
                <TableRow>
                    <TableCell colSpan={colCount} align="center" sx={{ py: 6 }}>
                        <CircularProgress size={28} />
                    </TableCell>
                </TableRow>
            ) : finesList.length === 0 ? (
                <TableRow>
                    <TableCell colSpan={colCount} align="center" sx={{ py: 6, color: 'text.secondary' }}>
                        Нет штрафов за выбранный период
                    </TableCell>
                </TableRow>
            ) : pagedFines.map(({fine_date, fine_id, worker_name, fine_amount, comment, created_by}) => (
            <TableRow key={fine_id} hover>
                <TableCell>{fine_date}</TableCell>
                <TableCell>{worker_name}</TableCell>
                <TableCell align="right">{fine_amount}</TableCell>
                <TableCell sx={{whiteSpace: "normal", wordWrap: "break-word"}}>{comment}</TableCell>
                <TableCell>{created_by || '-'}</TableCell>
                <TableCell>
                <Button
                    variant="outlined"
                    onClick={() => showEditFineModal(fine_id)}>Изменить</Button>
                </TableCell>
            </TableRow>
            ))}
            </TableBody>
            </Table>
            </TableContainer>
            {!loading && finesList.length > 0 && (
            <TablePagination
                component="div"
                count={finesList.length}
                page={page}
                onPageChange={(e, p) => setPage(p)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
                rowsPerPageOptions={[10, 25, 50, 100]}
                labelRowsPerPage="Строк на странице:"
            />
            )}

            <Modal
            open={addFineOpen}
            onClose={handleAddFineClose}
            >
            <AddFine availableWorkers={availableWorkers}/>
            </Modal>

            <Modal
            open={editFineOpen}
            onClose={handleEditFineClose}
            >
            <EditFine editedFineId={editedFineId} availableWorkers={availableWorkers} setEditWindowOpen={setEditFineOpen}/>
            </Modal>
        </>
    )
}
